/**
 * Factory functions for creating chat message entities.
 */

import type { ChatMessageEntity } from '@saaga/shared/store/slices/chat-message-entity.interface'

interface UserInfo {
  id?: string
  fullName?: string | null
  username?: string | null
  imageUrl?: string
}

const createOptimisticId = (): string => `pending-${Date.now()}`

const createStableKey = (): string => `opt-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

interface CreateOptimisticEntityParams {
  content: string
  type: 'message' | 'note'
  conversationId: string | null
  user: UserInfo | null | undefined
}

export const createOptimisticEntity = ({
  content,
  type,
  conversationId,
  user,
}: CreateOptimisticEntityParams): ChatMessageEntity => ({
  id: createOptimisticId(),
  conversationId: conversationId ?? 'pending',
  type,
  content,
  timestamp: new Date().toISOString(),
  stableKey: createStableKey(),
  sender: 'user',
  participant: {
    id: user?.id ?? 'unknown',
    name: user?.fullName ?? user?.username ?? 'You',
    avatarUrl: user?.imageUrl,
  },
  isPending: true,
  isStreaming: false,
  streamingContent: '',
})
